import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEquals = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#4A5468"
      d="M4.376 5.723a.6.6 0 0 1 .6-.6h6.048a.6.6 0 1 1 0 1.2H4.976a.6.6 0 0 1-.6-.6m0 4.555a.6.6 0 0 1 .6-.6h6.048a.6.6 0 1 1 0 1.2H4.976a.6.6 0 0 1-.6-.6"
    />
  </svg>
);
export default SvgEquals;
